import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        padding: '0.2rem 1rem .5rem 1rem',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexGrow: 1
    },
    buttonToolbar: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        paddingLeft: '2rem',
        flexBasis: 'auto' as const,
        marginBottom: '.5rem'
    },
    closedWalletsButton: {
        display: 'flex' as const,
        alignItems: 'center' as const,
        height: '1rem',
        cursor: 'pointer' as const,
        textTransform: 'none' as const,
        fontSize: '.8rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginLeft: '1rem',
        padding: '.25rem .75rem',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        border: `1px solid ${theme?.app?.clientTheme.colors.primaryColor ||
        '#375073'}`,
        borderRadius: '20px',
        '&:hover': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
                '#F3F3F3'
        },
        '&:first-child': { marginLeft: 0 }
    },
    closedWalletsFilterActive: {
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark ||
            '#0A2240',
        '&:hover': {
            color: theme?.app?.clientTheme.colors.primaryColor ||
                '#375073'
        }
    },
    walletsGridContainer: {
        minHeight: '340px',
        position: 'relative' as const,
        flexGrow: 1
    },
    exportButton: {
        position: 'absolute' as const,
        top: '.25rem',
        right: 0,
        zIndex: 10
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    }
});